export {default as TrunsactionsPage} from "./transactions-page.vue"
